/* eslint-disable */

export const CommerceRequirementKind = {
  Form: 'form',
  LegalAcceptance: 'legal_acceptance',
  TargetDetails: 'target_details',
  Authentication: 'authentication',
  TagEligibility: 'tag_eligibility',
  RequiredProduct: 'required_product',
  SpotSelection: 'spot_selection',
  ExistingRegistrationAcknowledgement: 'existing_registration_acknowledgement',
  DeferredGuestFollowup: 'deferred_guest_followup',
  GiftDetails: 'gift_details'
} as const;
export type CommerceRequirementKind = typeof CommerceRequirementKind[keyof typeof CommerceRequirementKind];
